import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'shop',
    component: () => import('../views/ShopView.vue'),
  },
  {
    path: '/account/:action?',
    name: 'account',
    component: () => import('../views/Account.vue'),
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/Payment.vue'),
  },
  {
    path: '/confirmation',
    name: 'confirmation',
    component: () => import('../views/Confirm.vue'),
  },
  {
    path: '/complete',
    name: 'complete',
    component: () => import('../views/Complete.vue'),
  },
  {
    path: '/premium-monthly',
    name: 'premium-monthly',
    component: () => import('../views/PremiumMonthlyPromoView.vue'),
  },
  {
    path: '/eeda-presale',
    name: 'eeda-presale',
    component: () => import('../views/EDAPremiumPreSaleView.vue'),
  },
  {
    path: '/boogo',
    name: 'boogo',
    component: () => import('../views/BooGoView.vue'),
  },
  {
    path: '/black-friday',
    name: 'black-friday',
    component: () => import('../views/BlackFriday.vue'),
  },
  {
    path: '/leap-year-2024',
    name: 'leap-year-2024',
    component: () => import('../views/LeapYearView.vue'),
  },
  // Always leave this route as last one.
  {
    path: '*',
    redirect: '/',
  },
]

export default routes
